import Alpine from 'alpinejs';
import Onboard, {WalletState} from '@web3-onboard/core';
import coinbaseWalletModule from '@web3-onboard/coinbase';
import walletConnectModule from '@web3-onboard/walletconnect'
import injectedModule from '@web3-onboard/injected-wallets'
import Web3 from 'web3';
import LmwrCoinbasePromoNftV1 from "../LmwrCoinbasePromoNftV1.js";

window["Alpine"] = Alpine

//const CONTRACT_ADDRESS = "0xEf28f70b44859422403a9e0c6372D0e1EB118b26";
const CONTRACT_ADDRESS = "0x43d2b22eb66a95240fd4c48bcd3a8923bf1649f1";
const BASE_TESTNET_ID = 84532;
const BASE_TESTNET_SETTINGS = {
    chainId: BASE_TESTNET_ID,
    chainNamespace: "evm",
    rpcUrl: "https://sepolia.base.org",
    label: "Base Sepolia Testnet",
    token: "ETH"
}
const BASE_MAINNET_ID = 8453;
const BASE_MAINNET_SETTINGS = {
    chainId: BASE_MAINNET_ID,
    chainNamespace: "evm",
    rpcUrl: "https://mainnet.base.org",
    label: "Base Mainnet",
    token: "ETH"
}

const chainId = BASE_MAINNET_ID;
const chainSettings = BASE_MAINNET_SETTINGS;

const walletDataRaw = {
    walletConnected: false,
    walletLabel: undefined,
    account: undefined,
    ethBalance: undefined,
    nfts: [],
    reveal: null,

    mintingAvailable: function () {
        return Date.now() < 1721404800 * 1000;
    },
    //mintPrice: 1000000000000,
    mintPrice: 1000000000000000,
    mintingInProgress: false,
    mintingStatusText: null,
    mintingError: false,
}
Alpine.data('walletData', () => (walletDataRaw));
const data = Alpine.reactive(walletDataRaw);

// initialize the module with options
const injected = injectedModule()
const coinbaseWalletSdk = coinbaseWalletModule({darkMode: true})
const walletConnect = walletConnectModule({
    projectId: "74dc73223f0b737ac1392afcca110a87",
    dappUrl: "https://lmwr.com/",
    requiredChains: [chainId],
})
// can also initialize with no options...
// const coinbaseWalletSdk = coinbaseWalletSdk()

const onboard = Onboard({
    // ... other Onboard options
    wallets: [
        injected,
        coinbaseWalletSdk,
        walletConnect
    ],
    chains: [
        {
            id: chainId
        }
    ],
    connect: {
        autoConnectLastWallet: true,
    },
    accountCenter: {
        mobile: {
            enabled: false
        },
        desktop: {
            enabled: false
        }
    },
    notify: {
        enabled: false
    },
    apiKey: "f9df0476-b7b8-4590-93f6-d650fdbd20f8",
    appMetadata: {
        name: "lmwr.com",
        description: "lmwr.com is the official project website of the lmwr token",
        icon: new URL("../../img/limewire_icon.svg", import.meta.url).toString(),
        logo: new URL("../../img/limewire_logo.svg", import.meta.url).toString(),
    },
    theme: 'dark'
});

const state = onboard.state.select('wallets');
state.subscribe(async function (update) {
    console.log("Wallets have changed", update);
    if (update.length > 1) {
        console.log("Forbidden: More than 1 wallet - disconnecting and reconnecting");
        await window.disconnectWallet();
        await onboard.connectWallet();
    } else {
        await refreshData(onboard.state.get().wallets);
    }
})

let lastConnectedWallet = JSON.parse(localStorage.getItem("onboard.js:last_connected_wallet") || "[]");
if (Array.isArray(lastConnectedWallet) && lastConnectedWallet.length) {
    console.log(`Trying to reconnect to wallet ${lastConnectedWallet[0]}`)
    onboard.connectWallet({
        autoSelect: {
            label: lastConnectedWallet[0],
            disableModals: true
        }
    });
}

async function changeChain() {
    const wallets = onboard.state.get().wallets;
    if (wallets.length > 0) {
        if (parseInt(wallets[0].chains[0].id, 16) !== chainId) {
            try {
                await onboard.setChain({
                    ... chainSettings,
                    wallet: wallets[0].label
                });
            } catch (e) {
                console.log("Error changing chains on wallet", e);
            }
            return true;
        }
    }
    return false;
}

async function refreshData(walletStates) {
    let hadToChangeChain = await changeChain();
    if (hadToChangeChain || !walletStates || walletStates.length === 0) {
        console.log("No connected wallets found or chain was changed");
        data.walletConnected = false;
        data.walletLabel = undefined;
        data.account = undefined;
        data.ethBalance = undefined;
        data.nfts = [];
        data.reveal = null;
    } else {
        if (walletStates[0].accounts[0].address === data.account?.address) {
            console.log("Empty update - doing nothing");
            return;
        }
        const web3 = new Web3({
            provider: walletStates[0].provider,
            config: {defaultNetworkId: chainId},
        });
        data.reveal = null;
        data.walletLabel = walletStates[0].label;
        data.account = walletStates[0].accounts[0];
        const address = data.account.address;
        data.ethBalance = await web3.eth.getBalance(address);
        data.walletConnected = true;
        console.log(`Wallet ${address} has an ETH balance of ${data.ethBalance} WEI`);
        const contract = new web3.eth.Contract(LmwrCoinbasePromoNftV1, CONTRACT_ADDRESS);
        contract.defaultAccount = address;
        const balance = await contract.methods.balanceOf(address).call();
        console.log(`Address ${address} has a balance of ${balance} tokens`);
        for (let i = 0; i < balance; i++) {
            const tokenId = await contract.methods.tokenOfOwnerByIndex(address, i).call();
            console.log(`Address ${address} owns token ${tokenId}`);
            const category = await contract.methods.getTokenCategory(tokenId).call();
            console.log(data.nfts.length, data.walletConnected);
            data.nfts.push({
                id: tokenId,
                category: category,
                image: getNftImageUrl(category),
                animationUrl: getNftAnimationUrl(category),
            });
        }
    }
}

function getNftImageUrl(category) {
    switch (Number(category)) {
        case 0:
            return new URL("./media/promos_base2024_3_0_image.png", import.meta.url).toString()
        case 1:
            return new URL("./media/promos_base2024_3_1_image.png", import.meta.url).toString()
        case 2:
            return new URL("./media/promos_base2024_3_2_image.png", import.meta.url).toString()
        case 3:
            return new URL("./media/promos_base2024_3_3_image.png", import.meta.url).toString()
    }
}

function getNftAnimationUrl(category) {
    switch (Number(category)) {
        case 0:
            return new URL("./media/promos_base2024_3_0_video.mp4", import.meta.url).toString()
        case 1:
            return new URL("./media/promos_base2024_3_1_video.mp4", import.meta.url).toString()
        case 2:
            return new URL("./media/promos_base2024_3_2_video.mp4", import.meta.url).toString()
        case 3:
            return new URL("./media/promos_base2024_3_3_video.mp4", import.meta.url).toString()
    }
}

window["connectWallet"] = async function () {
    await onboard.connectWallet();
}

window["disconnectWallet"] = async function () {
    for (const walletstate of onboard.state.get().wallets) {
        await onboard.disconnectWallet({label: walletstate.label});
    }
}

window["mint"] = async function () {
    try {
        data.mintingError = false;
        data.mintingInProgress = true;
        data.mintingStatusText = "Estimating Gas Fees ...";
        const wallet = onboard.state.get().wallets[0];
        const web3 = new Web3({
            provider: wallet.provider,
            config: {defaultNetworkId: chainId, handleRevert: true},
        });
        const address = wallet.accounts[0].address;
        const contract = new web3.eth.Contract(LmwrCoinbasePromoNftV1, CONTRACT_ADDRESS);
        const estimatedGas = await contract.methods.mint().estimateGas({
            from: address,
            value: data.mintPrice
        });
        console.log("Estimated gas", estimatedGas);
        data.mintingStatusText = "Sending transaction ...";
        const numberOfNftsBeforeMinting = data.nfts.length || 0;
        const res = await contract.methods.mint().send({
            from: address,
            value: data.mintPrice,
            gas: estimatedGas,
        });
        console.log("Successfully sent minting tx", res);
        data.mintingStatusText = "Minting transaction sent - waiting for Non-Fungible Torrent";
        setTimeout(() => {
            const checkForNft = async () => {
                try {
                    console.log("Checking for NFT ...");
                    const balance = await contract.methods.balanceOf(address).call();
                    if (balance > numberOfNftsBeforeMinting) {
                        data.mintingInProgress = false;
                        data.mintingStatusText = "Minting complete - enjoy your new Non-Fungible Torrent!";
                        data.mintingError = false;
                        setTimeout(() => location.reload(), 5_000);
                    } else {
                        console.log("Not yet found ...");
                        setTimeout(checkForNft, 10_000);
                    }
                } catch (e) {
                    console.log("Error checking for NFT", e);
                    data.mintingStatusText = "An error occurred while checking for your NFTs - please refresh the page";
                    data.mintingError = true;
                }
            }
            checkForNft();
        }, 10_000);
    } catch (e) {
        console.log("Error minting", e);
        data.mintingError = true;
        data.mintingStatusText = `Error: ${e}`
        data.mintingInProgress = false;
    }
}

window["downloadLink"] = function (id) {
    let url = "";
    switch (Number(id)) {
        case 1:
            url = new URL("media/deadmau5 - Apnea.m4a", import.meta.url);
            break;
        case 2:
            url = new URL("media/Sean Kingston - Sally.mp3", import.meta.url);
            break;
    }
    console.log("Downloadlink: ", url, id);
    return url.toString();
}

Alpine.start();

